import curdGenerator from "./curdGenerator";

export const masters = [
  { module: "Dashboard", permission: "dashboard", children: [] },
  {
    module: "Masters",
    children: [
      curdGenerator("Country"),
      curdGenerator("State"),
      curdGenerator("City"),
      curdGenerator("Area"),
      curdGenerator("Department"),
      curdGenerator("ConsultantSpecialization"),
      curdGenerator("Consultant"),
      curdGenerator("Staff"),
      curdGenerator("Case"),
      curdGenerator("Billing Charges Group"),
      curdGenerator("Billing Charges"),
      curdGenerator("Group Account"),
      curdGenerator("Ledger Account"),
      curdGenerator("Patient")
    ]
  }
];
